<template>
  <div class="page-login">
    <div class="login-container">
      <div class="cover">
        <div class="title">正汇通溜溜测评管理系统</div>
        <div class="desc">ZHT Invertory System Platform</div>
      </div>
      <div class="widget" v-if="!forgetPwd">

          <!--<h3 class="login_title">用户登录 <span class="desc">USER LOGIN</span></h3>-->
          <el-tabs v-model="loginType" @tab-click="switchLogin" class="switch-tabs">
            <el-tab-pane label="账号登录" name="username">
              <el-form class="widget-form" :rules="loginRule" ref="loginForm" :model="loginForm" size="medium">
                <el-form-item prop="username">
                  <el-input prefix-icon="el-icon-user-solid" type="text" v-model="loginForm.username" placeholder="请输入手机号码或者电子邮箱"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input prefix-icon="el-icon-key" type="password" v-model="loginForm.password" @keyup.enter="handleLogin" placeholder="请输入密码"></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="短信登录" name="captcha">
              <el-form class="widget-form" :rules="captchaRule" ref="captchaForm" :model="captchaForm" size="medium">
                <el-form-item prop="phone">
                  <el-input prefix-icon="el-icon-mobile" type="text" show-word-limit :clearable="true" v-model="captchaForm.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-input prefix-icon="el-icon-message" type="text" v-model="captchaForm.code" placeholder="请输入短信验证码" :clearable="true">
                    <el-button slot="append" @click="fetchCaptcha" :disabled="disabled">{{ text }}</el-button >
                  </el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <div class="btn-submit-wrap">
            <el-button type="primary" @click="handleLogin" :loading="submitLoading">登 录</el-button>
          </div>
          <div class="register-wrap">
            <div><span>还没有账号?</span><el-link type="primary" @click="toRegister">立即注册</el-link></div>
            <el-link type="primary" @click="toChangePwd">忘记登录密码?</el-link>
          </div>

      </div>
      <div class="widget" v-else>
        <forget-password @done="backLoginPage"></forget-password>
      </div>
    </div>
  </div>
</template>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import {fetchVerify} from "@api/system/user";
import ForgetPassword from "./ForgetPassword";

export default {
  components: {
    ForgetPassword,
  },
  mixins: [sendVerifyCode],
	data() {
		return {
			loginForm: {},
      captchaForm: {
			  code:null,
        phone:null
      },
      loginType:'username',
      forgetPwd:false,
			submitLoading: false,
      loginRule: {
        username: [
          {required: true, message: '请输入手机号码或者电子邮箱', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
      },
      captchaRule:{
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { required: true, message: '请输入正确的电话号码', trigger: 'blur',pattern:/^1(3|4|5|7|8|9|6)\d{9}$/ },
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      }
		}
	},
  methods: {
		toRegister() {
			this.$router.push('/register')
		},
    toChangePwd() {
			this.forgetPwd = true
		},
    backLoginPage(){
      this.forgetPwd = false
    },
    switchLogin(tab,event){

    },
    fetchCaptcha() {
		  let that = this
      this.$refs["captchaForm"].validateField("phone",flag => {
        if(flag){
          console.log(flag,'失败！！！')
        }else{
          fetchVerify(this.captchaForm.phone,'login').then(resp => {
            this.captchaForm.code = ''
            that.sendCode();
          })
        }
      })
    },
    handleLogin(){
      if(this.loginType === 'username'){
        this.userLogin()
      }else{
        this.captchaLogin()
      }
    },
    toIndex(){
      this.$store.dispatch('user/getInfo').then(resp => {
        let { company } = resp
        if(!company){
          this.$router.replace('/join/company')
        }else{
          this.$router.replace('/')
        }
      })
    },
    userLogin() {
      this.submitLoading = false
      this.$refs['loginForm'].validate(valid => {
				if (valid) {
					this.submitLoading = true

          this.$store.dispatch('user/login', this.loginForm).then(() => {
           this.toIndex()
          }).catch(error => {
            this.submitLoading = false
          })
				}
			})
		},
    captchaLogin() {
      this.submitLoading = false
      this.$refs['captchaForm'].validate(valid => {
				if (valid) {
					this.submitLoading = true

          this.$store.dispatch('user/mobileLogin', this.captchaForm).then(() => {
            this.toIndex()
          }).catch(error => {
            this.submitLoading = false
          })
				}
			})
		}
	}
}
</script>
<style lang="scss">
.page-login {
	background: url('~@assets/images/login_bg2.jpg') 0 0 no-repeat;
	background-size: cover;
	height: 100vh;
	width: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Microsoft Yahei Regular', sans-serif;
}

.login-container {
  width: 650px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.149019607843137);
  display: flex;
  background-color: #fff;
  overflow:hidden;
  height: 420px;
  margin-top: 10%;

  .cover{
    padding: 0 15px;
    background: url('~@assets/images/login-cover1.svg') 0 center #409eff no-repeat;
    width:230px;
    height: 420px;
    text-align: center;
    background-size: contain;

    .title{
      margin-top: 60px;
      font-size: 20px;
      color:#fff;
      font-weight: 700;
    }
    .desc{
      font-size: 14px;
      color:rgb(255,255,255,0.8);
    }
  }
}

.widget{
  flex: 1;
  background-clip: padding-box;
  width: 310px;
  min-height: 370px;
  padding: 20px 35px;
  background: #fff;

  .widget-form{
    margin-top: 10px;
  }

  .login_title{
    color:#666;
    font-size: 18px;
    font-weight: 700;
    margin-top:20px;
    margin-bottom: 25px;

    .desc{
      color:#999;
      font-weight: 400;
      font-size: 14px;
    }
  }

  .btn-submit-wrap{
    margin: 30px 0 10px;

    .el-button{
      width:100%;
      font-size: 14px;
    }
  }
}

.switch-tabs{
  margin-top: 20px;
  .el-tabs__content{
    padding: 20px 0;
  }
  .el-tabs__item{
    color:#666666;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
  }
  .el-tabs__active-bar{
    height: 4px;
    border-radius: 2px;
  }
  .el-tabs__nav-wrap::after{
    height: 4px;
  }
}

.register-wrap{
  display: flex;
  justify-content: space-between;
  color:#999;
  align-items: flex-end;
  .el-link{
    vertical-align:initial;
  }

}
</style>
